<template>
  <div>
    <p>{{ $t('page-not-found') }}</p>
  </div>
</template>

<script>
import appHelpers from '@/helpers/app.helpers'

export default {
  beforeCreate () {
    // Redirect to app-test.opensalud.es
    if (!this.$route.fullPath.includes('static-appopensalud')) {
      window.location.href = `${appHelpers.getAppUrl(this.$route.fullPath)}`
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/errors/NotFoundErrorPage.vue